export default "__VITE_ASSET__CFwhoLa0__"